<div class="validation-rule">
  <div class="row auto full-width">
    <validation-field-option [rule]="rule" [value]="rule.field" [fields]="fields"
                             (selectedFieldChanged)="rule.field=$event"></validation-field-option>
    <validation-query-operator [rule]="rule" [field]="fields[rule.field]"
                               (selectedOperatorChanged)="rule.operator=$event"></validation-query-operator>
    <validation-query-value [fields]="fields" [rule]="rule" [operator]="rule.operator"
                            [selectedField]="fields[rule.field]"></validation-query-value>
  </div>
  <button type="button" class="trash-button" mat-icon-button color="primary" (click)="removeRule()" data-testid="vb-remove-rule">
    <mat-icon class="button-icon"><i class="fa fa-trash"></i></mat-icon>
  </button>
</div>
